import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns an array of ReadWriteRecipientViewState containing recipient and implicit group members.
 */
export default function(item: ReadWriteRecipientViewState): boolean {
    return (
        isFeatureEnabled('cmp-implicitgroups') &&
        item &&
        item.persona &&
        item.persona.PersonaTypeString == 'ImplicitGroup' &&
        item.persona.Members &&
        item.persona.Members.length > 0
    );
}
